export default __webpack_public_path__ + "media/fonts/foundation-icons/foundation-icons-c0cbb004854f9c746f89e17ab5969370.ttf";